import { IFilterMultiSelectOption } from 'transfix-ui'

export const BROKER_POD_OPTIONS_LEGACY: IFilterMultiSelectOption[] = [
  {
    label: 'Green Broker Pod',
    value: 'green_broker_pod',
    selected: false,
  },
  {
    label: 'Blue Broker Pod',
    value: 'blue_broker_pod',
    selected: false,
  },
  {
    label: 'Yellow Broker Pod',
    value: 'yellow_broker_pod',
    selected: false,
  },
]

export const BROKER_POD_OPTIONS_NEW: IFilterMultiSelectOption[] = [
  {
    label: 'Green Broker Pod',
    value: 'green_broker_pod',
    selected: false,
  },
  {
    label: 'Blue Broker Pod',
    value: 'blue_broker_pod',
    selected: false,
  },
  {
    label: 'Yellow Broker Pod',
    value: 'yellow_broker_pod',
    selected: false,
  },
  {
    label: 'Orange Broker Pod',
    value: 'orange_broker_pod',
    selected: false,
  },
  {
    label: 'Red Broker Pod',
    value: 'red_broker_pod',
    selected: false,
  },
]
